@if (eventName(); as eventName) {
    @switch (eventName) {
        @case (MaloupeEventName.EQUIP_HOTEL) {
            <app-equip-hotel-ranking></app-equip-hotel-ranking>
        }
        @default {
            <app-event-ranking [eventName]="eventName"></app-event-ranking>
        }
    }
}
